// extracted by mini-css-extract-plugin
module.exports = {"leftArrowLinkButton":"leftArrowLinkButton_2AhO5","linkText":"linkText_h2Gj_"};